import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  select(event) {
    const button = event.target.closest("[data-start][data-end]")
    if (!button) return

    const form = document.getElementById("sales_stats_form")
    if (!form) return

    const startDate = form.querySelector("[name='start_date']")
    const endDate = form.querySelector("[name='end_date']")

    if (startDate) startDate.value = button.dataset.start
    if (endDate) endDate.value = button.dataset.end

    form.requestSubmit()
  }
}
